export default __webpack_public_path__ + "static/media/leafs.b2399d06.svg";